module.exports = __webpack_public_path__ + "img/20200512_162916.16adac34.jpg";